module.exports = __webpack_public_path__ + "img/bianYaQi2.f986068d.png";